var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#E8751E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.534 32.2015L38.532 32.2022C37.5209 32.5379 36.9733 33.6296 37.3089 34.6408L45.672 59.8356C46.0077 60.8468 47.0995 61.3944 48.1106 61.0588L48.1126 61.0581C49.1238 60.7225 49.6714 59.6307 49.3358 58.6195L40.9727 33.4247C40.637 32.4135 39.5452 31.8659 38.534 32.2015Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0057 49.2415L13.0037 49.2422C11.9925 49.5778 11.4449 50.6696 11.7806 51.6808L15.0212 61.4435C15.3569 62.4547 16.4486 63.0023 17.4598 62.6666L17.4618 62.666C18.473 62.3303 19.0206 61.2386 18.6849 60.2274L15.4443 50.4647C15.1086 49.4535 14.0169 48.9059 13.0057 49.2415Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4396 59.1115L18.5843 59.8959L15.791 51.4809L37.5572 35.3652L45.4396 59.1115Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.652 59.485C34.9556 60.5958 34.9145 61.7729 34.534 62.861C34.1536 63.9492 33.4517 64.8973 32.521 65.5803C31.5903 66.2633 30.4745 66.6491 29.3206 66.6868C28.1668 66.7245 27.0291 66.4123 26.0578 65.7915C25.0864 65.1707 24.3269 64.2703 23.8795 63.2092C23.432 62.1481 23.3176 60.9761 23.5514 59.8477",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.173 32.6481L50.0377 38.8511C54.053 37.0892 57.444 34.5896 60.4405 31.8086M60.4405 31.8086C64.8845 30.3503 68.0003 27.1203 68.0003 23.3442C68.0003 18.2054 62.2724 14.0397 55.2067 14.0397C48.141 14.0397 42.4131 18.2054 42.4131 23.3442C42.4131 28.1924 47.6625 32.2138 54.1729 32.6486",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.173 32.6481L50.0377 38.8511C54.053 37.0892 57.444 34.5896 60.4405 31.8086M60.4405 31.8086C64.8845 30.3503 68.0003 27.1203 68.0003 23.3442C68.0003 18.2054 62.2724 14.0397 55.2067 14.0397C48.141 14.0397 42.4131 18.2054 42.4131 23.3442C42.4131 28.1924 47.6625 32.2138 54.1729 32.6486",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c615ec25d4d6c20b8f87cc13c664dc28.svg";
export { ForwardRef as ReactComponent };